import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-popovercomponent',
    templateUrl: './popovercomponent.component.html',
    styleUrls: ['./popovercomponent.component.css'],
    standalone: false
})
export class PopovercomponentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
